/**
 * Edge functions answer errors as {"status": n, "message": "..."} (some older
 * ones use {"error": "..."}). supabase-js surfaces only a generic
 * "non-2xx status code" message, so callers unwrap the real one from
 * error.context via this helper.
 */
export const unwrapFunctionMessage = (payload: unknown): string | null => {
  if (payload == null || typeof payload !== "object") return null;
  const body = payload as { message?: unknown; error?: unknown };
  if (typeof body.message === "string" && body.message) return body.message;
  if (typeof body.error === "string" && body.error) return body.error;
  return null;
};
